module.exports = __webpack_public_path__ + "img/图片10.fe4d661a.png";